import React from 'react';
import PromoBanner from '../PromoBanner';

// Parse hero title text:
// - `\n` → line break
// - text wrapped in `*` → italic emphasis
// Lets the admin write `"Premium shade,\\nbuilt to *your space*"`
// in the storefront content editor without authoring HTML.
function renderHeroTitle(text) {
  if (!text) return null;
  return text.split('\\n').map((line, i) => {
    const parts = line.split(/\*(.*?)\*/g);
    return (
      <React.Fragment key={i}>
        {i > 0 && <br />}
        {parts.map((part, j) => (j % 2 === 1 ? <em key={j}>{part}</em> : part))}
      </React.Fragment>
    );
  });
}

// Top-of-page hero: dynamic background image, h1 + subtitle + two
// CTAs + promo banner. Label, title, subtitle, and both CTA labels
// are admin-editable.
export default function Hero({ settings }) {
  return (
    <section className="asg-hero">
      <div className="asg-hero-bg" style={{ backgroundImage: `linear-gradient(145deg, rgba(42,37,32,0.55) 0%, rgba(var(--asg-text-rgb),0.6) 40%, rgba(15,15,14,0.7) 100%), url(${settings.hero_image ?? '/uploads/gallery/hero-image-1.webp'})` }}></div>
      <div className="asg-hero-grain"></div>
      <div className="asg-hero-lines"></div>
      <div className="asg-hero-content">
        <p className="asg-hero-label">{settings.hero_label ?? 'Awnings & Pergolas'}</p>
        <h1 className="asg-hero-title">
          {renderHeroTitle(settings.hero_title ?? 'Premium shade,\\nbuilt to *your space*')}
        </h1>
        <div className="asg-hero-divider"></div>
        <p className="asg-hero-sub">
          {settings.hero_subtitle ?? 'Marine-grade aluminium frames, Spanish Sauleda fabric and Dooya motors - sourced globally, assembled and tested at our Melbourne warehouse. Made to measure, with free local delivery on awnings across Melbourne metro.'}
        </p>
        <div className="asg-hero-cta">
          <a href="#quote" className="asg-btn-primary">{settings.hero_cta_primary ?? 'Get a No-Obligation Quote'}</a>
          <a href="#range" className="asg-btn-ghost">{settings.hero_cta_secondary ?? 'Explore Products'}</a>
        </div>
        <PromoBanner href="#range" />
      </div>
      <div className="asg-hero-scroll">
        <span>Scroll</span>
        <div className="asg-scroll-line"></div>
      </div>
    </section>
  );
}
